
import {Component, Input, OnInit} from '@angular/core';
import {TrackingService} from '@ox/data';
import {TranslateService} from '@ox/translate';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {RecallsGfasService} from '@ox/recalls';
import {ExpandCollection} from '@ox/typings';


@Component({
  selector: 'webu-recall-center-search',
  templateUrl: './search-webu.html'
})
export class RecallCenterSearchComponent implements OnInit {
  @Input() isAnotherSearch: boolean;
  @Input() landingFaq: ExpandCollection[];
  @Input() vinAttributes: {pattern: RegExp, maxlength: number};
  @Input() refreshDate: string;

  public currentPageName = '';
  public recallSearchForm: FormGroup;

  constructor (
    private fb: FormBuilder,
    private recallService: RecallsGfasService
  ){

  }

  ngOnInit(){
    if(this.vinAttributes?.maxlength && this.vinAttributes?.pattern){
      this.recallSearchForm = this.fb.group({
        searchInput: new FormControl('', [
          Validators.maxLength(this.vinAttributes.maxlength),
          Validators.required,
          Validators.pattern(this.vinAttributes.pattern)
        ])
      });
    }
  }

  searchForRecalls(value: {[key:string]:string}) {
    this.recallService.searchedVinEmitter.next(value['searchInput']);
  }
}
